import React, { useEffect, useRef, useState } from "react";
import { BodyText, Checkbox, FilterDropdown, Heading, Input, PrimaryButton, Textarea } from "../../elements";
import "./style.scss";
import { getApiError, getCommentsCountryOptions, getGenderOptions } from "../../services/siteService";
import { loadGMap } from "../../utils/siteUtils";
import { useTranslation } from "react-i18next";
import { apiAsia } from "../../utils/api-asia";
import webcookie from "../../utils/webcookie";
import { emailFormat } from "../../utils/email";
import { gtag } from "../../utils";
import { S_PRIVACY_ID, S_COOKIE_VERSION, S_LANG, webStorage } from "../../utils/webStorage";
let submitting = false;
const ContactUs = props => {
  const { fields, page } = props;
  const isAR = page?.fields?.rtl?.value;
  const { t } = useTranslation();
  const other = t('ContactUs_Other') || 'Other';
  const {
    titleType,
    title,
    nameLabel,
    nameMissingMessage,
    genderLabel,
    genderMissingMessage,
    phoneLabel,
    phoneMissingMessage,
    phoneWarningMessage,
    phoneCodeLabel,
    phoneCodeMissingMessage,
    phoneCodeWarningMessage,
    emailLabel,
    emailMissingMessage,
    emailWarningMessage,
    countryLabel,
    countryMissingMessage,
    cityLabel,
    cityMissingMessage,
    commentsLabel,
    commentsMissingMessage,
    policyLabel,
    policyMissingMessage,
    submitBtnText,
    submitBtnIcon,
    submitBtnColorScheme,
    successTitle,
    successBody,
		aftersalesSuccessTitle,
		aftersalesSuccessBody,
    language,
		topicLabel,
		identityLabel,
		topicMissingMessage,
		identityMissingMessage,
		topicData,
		indentifyData,
		topicDefault
  } = fields;
  let lang = language?.fields?.phrase?.value ? language?.fields?.phrase?.value : 'en';
  let langName = language?.fields?.key?.value ? language?.fields?.key?.value : 'English';
  webStorage.set(S_LANG, lang);
  const rootNode = useRef(null);
	const phoneCodeNode = useRef();
  const [submitted, setSubmitted] = useState(false);
  const [enteredName, setEnteredName] = useState(null);
  const [nameError, setNameError] = useState(null);
  const [genderOptions, setGenderOptions] = useState([]);
  const [selectedGender, setSelectedGender] = useState(null);
  const [genderError, setGenderError] = useState(null);
  const [enteredPhone, setEnteredPhone] = useState(null);
  const [selectedPhoneCode, setSelectedPhoneCode] = useState(null);
  const [phoneIsValid, setPhoneIsValid] = useState(false);
  const [phoneCodeOptions, setPhoneCodeOptions] = useState([]);
  const [phoneError, setPhoneError] = useState(null);
  const [phoneCodeError, setPhoneCodeError] = useState(null);
  const [enteredEmail, setEnteredEmail] = useState(null);
  const [emailIsValid, setEmailIsValid] = useState(false);
  const [emailError, setEmailError] = useState(null);
  const [countryOptions, setCountryOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [country, setCountry] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
	const [selectedTopic, setSelectedTopic] = useState(null);
	const [topicError, setTopicError] = useState(null);
	const [selectedIdentity, setSelectedIdentity] = useState(null);
	const [identityError, setIdentityError] = useState(null);
  const [countryError, setCountryError] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [cityError, setCityError] = useState(null);
  const [enteredComments, setEnteredComments] = useState("");
  const [commentsError, setCommentsError] = useState(null);
  const [policyChecked, setPolicyChecked] = useState(null);
  const [policyError, setPolicyError] = useState(null);
  const [serverError, setServerError] = useState(null);
  const [defaultCode, setDefaultCode] = useState('');
  const [currentPos, setCurrentPos] = useState(false);
	const [topicList, setTopicList] = useState([]);
	const [defaultTopic, setDefaultTopic] = useState(null);
	const [indentifyList, setIndentifyList] = useState([]);
  const init = async () => {
    getCountry()
		getTopic()
		getIndentifyList()
		navigator.geolocation.getCurrentPosition(function(showPosition) {
			getIp();
			setCurrentPos(true);
		})
  };
	const getTopic = () => {
		let topicList = [];
		topicData.forEach(v=>{
		  topicList.push({
		    code : v.fields.code.value,
		    value : v.fields.value.value,
		  })
		})
		setTopicList(topicList)
		if(topicDefault) {
			let item = topicList.find((x) => x.code == topicDefault?.fields?.phrase?.value);
			setSelectedTopic(item);
		}
	};
	const getIndentifyList = () => {
		let indentifyList = [];
		indentifyData.forEach(v=>{
		  indentifyList.push({
		    code : v.fields.code.value,
		    value : v.fields.value.value,
		  })
		})
		setIndentifyList(indentifyList)
		if(topicDefault?.fields?.phrase?.value === 'aftersales') {
			let item = indentifyList.find((x) => x.code == 'owner');
			setSelectedIdentity(item);
		}
	};
  const getCountry = async () => {    
    apiAsia.form.country({language: langName}).then(res => {
      if (!!res[0]) {
        let countrtList = []
        let codeList = []
        res[0].forEach(v=>{
          countrtList.push({
            code : v.countryCode,
            value : v.countryName
          })
          codeList.push({
            code : v.countryCode,
            value: `+${v.phoneAreaCode}`,
            values : ` (${v.countryName})`
          })
        })
        codeList.push({
          code:'editSelect',
          value: other,
        })
        setCountryOptions(countrtList);
        setPhoneCodeOptions(codeList);
        getCountryCode(countrtList);
      }
    })
    .catch(err => {
      console.log(err)
    });
  };
  const getIp = async () => {
    apiAsia.form.ip({language: langName}).then(res => {
      if (!!res[0]) {
        setSelectedPhoneCode({
          code : res[0].countryCode,
          value: `+${res[0].phoneAreaCode}`,
          values : ` (${res[0].countryName})`
        })
      }
    })
    .catch(err => {
      console.log(err)
    });
  }
  const getArea = async (option) => {
    let params = {
      language: langName,
      countryCode: option.code,
      regionCode: null
    }
    apiAsia.form.area(params).then(res => {
      if (!!res[0]) {
        let data = res[0].map(v=>{
          v.code = v.regionCode
          v.value = v.regionName
          return v
        })
        setCityOptions(data);
      }
    })
  };
  const validateForm = () => {
    let valid = true;
    if (!enteredName) {
      setNameError(nameMissingMessage.value);
      valid = false;
    }
    // if (!selectedGender) {
    //   setGenderError(genderMissingMessage.value);
    //   valid = false;
    // }
    if (!phoneCodeNode.current.option?.value) {
      setPhoneCodeError(phoneCodeMissingMessage.value);
      valid = false;
    } else {
      let isValid = phoneCodeNumberVaild(enteredPhone , phoneCodeNode.current.option?.code);
      setPhoneError(isValid? null : phoneWarningMessage.value);
      if(!isValid) valid = isValid;
    }
    if (!enteredPhone) {
      setPhoneError(phoneMissingMessage.value);
      valid = false;
    } else {
      let isValid = phoneCodeNumberVaild(enteredPhone , phoneCodeNode.current.option?.code);
      setPhoneError(isValid? null : phoneWarningMessage.value);
      if(!isValid) valid = isValid;
    }

    if (!enteredEmail) {
      setEmailError(emailMissingMessage.value);
      valid = false;
    } else if (!emailIsValid) {
      setEmailError(emailWarningMessage.value);
      valid = false;
    }

    if (!selectedCountry) {
      setCountryError(countryMissingMessage.value);
      valid = false;
    }
		
		if (!selectedTopic) {
		  setTopicError(topicMissingMessage.value);
		  valid = false;
		}
		
		if (!selectedIdentity) {
		  setIdentityError(identityMissingMessage.value);
		  valid = false;
		}

    // if (!selectedCity) {
    //   setCityError(cityMissingMessage.value);
    //   valid = false;
    // }

    if (!enteredComments) {
      setCommentsError(commentsMissingMessage.value);
      valid = false;
    }

    if (!policyChecked) {
      setPolicyError(policyMissingMessage.value);
      valid = false;
    }

    return valid;
  };
  const getCountryCode = async (countrtList) => {
    const [res, ex] = await apiAsia.dealer.getCountryCode({});
    if(countrtList && countrtList.length > 0) {
      countrtList.forEach((item, index) => {
        if(item.code === res.countryCode) {
          setCountry(item);
        }
      })
    }
  }
  useEffect(() => {
	if (country && currentPos) {
	  setSelectedCountry(country);
	}
  }, [country, currentPos]);
  const onSubmit = async () => {
    let dataLayer = window.dataLayer || [];
    if (!submitting) {
      if (validateForm()) {
        webStorage.set(S_LANG, lang);
        submitting = true;
        const body = {
          userName: enteredName,
          phoneAreaCode: phoneCodeNode.current.option.value.replace(/\(.*?\)|（.*?\）|[+?]|\s*/g,""),
          phoneNum: enteredPhone,
          email: enteredEmail,
          // gender: selectedGender.code,
          country: selectedCountry.value,
          countryCode: selectedCountry.code,
          // region: selectedCity.value,
          // regionCode: selectedCity.code,
          opinion: enteredComments,
          language: langName,
          PrivacyId: webStorage.get(S_PRIVACY_ID),
          CookieCode: webcookie.getCookie('code'),
          CookieVersion: webStorage.get(S_COOKIE_VERSION),
					topic_identity: selectedIdentity.code,
					topic: selectedTopic.code
        };
        const [, ex] = await apiAsia.contact(null, body);
        submitting = false;
        if (ex) {
          const error = await getApiError(ex.code);
          setServerError(error);
          return;
        }
        gtag('event', 'contactus_clk', {
          'page_title': page?.name,
          'button_name': submitBtnText?.value
        });
        setSubmitted(true);
      }
    }
  };
  const nameProps = {
    label: nameLabel.value,
    value: enteredName,
    showError: !!nameError,
    warningMessage: nameError,
    onFocus() {
      setNameError(null);
    },
    onChange(e) {
      setNameError(null);
      setEnteredName(e.target.value);
    }
  };
  const genderProps = {
    placeholder: genderLabel.value,
    options: genderOptions,
    selectedOption: selectedGender,
    warningMessage: genderError,
    showError: !!genderError,
    onFocus() {
      setGenderError(null);
    },
    onChange(option) {
      setGenderError(null);
      setSelectedGender(option);
    }
  };
  const phoneProps = {
    // type: "tel",
    label: phoneLabel.value,
    value: enteredPhone,
    warningMessage: phoneError,
    showError: !!phoneError,
    onFocus() {
      setPhoneError(null);
    },
    onBlur(e, isValid) {
      let code = phoneCodeNode.current.option?.code;
      if (code && e.target.value) {
        setPhoneIsValid(phoneCodeNumberVaild(e.target.value, code));
        setPhoneError(phoneCodeNumberVaild(e.target.value, code) ? null : phoneWarningMessage.value);
        setEnteredPhone(e.target.value);
      }
      if(!code) {
        setPhoneIsValid(isValid);
        setPhoneError(isValid ? null : phoneWarningMessage.value);
        setEnteredPhone(e.target.value);
      }
    }
  };
  const phoneCodeNumberVaild = (value, code) => {
		let reg = /^(\d{8}|\d{9}|\d{10}|\d{11}|\d{12}|\d{13})$/;
    // if(code){
    //   code = code.replace(/\(.*?\)|（.*?\）|[+?]|\s*/g,"");
    //   if(code === 'SA'){
    //     reg=/^\d{9}$/
    //   }
    //   if(code == 'QA'){
    //     reg=/^\d{8}$/
    //   }
    //   if(code == 'KW'){
    //     reg=/^\d{8}$/
    //   }
    //   if(code == 'OM'){
    //     reg=/^\d{8}$/
    //   }
    //   if(code == 'AE'){
    //     reg=/^\d{9}$/
    //   }
    //   if(code == 'BH'){
    //     reg=/^\d{8}$/
    //   }
    // }
    let isValid = reg.test(value)
    setPhoneIsValid(isValid)
    return isValid
  }
  const onScroll = () => {
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight;
    if (rootNode?.current?.getBoundingClientRect()?.top < pageHeight) {
      gtag('event', 'contactus_exp', {
        'page_title': props?.page?.name
      });
    }
  }
  const phoneCodeProps = {
    reg:/\(.*?\)|（.*?\）/g,
    oneOfEdit: true,
    tel: true,
    maxlength: 10,
    selectCode: defaultCode,
    placeholder: phoneCodeLabel.value,
    options: phoneCodeOptions,
    selectedOption: selectedPhoneCode,
    warningMessage: phoneCodeError,
    showError: !!phoneCodeError,
    onFocus() {
      setPhoneCodeError(null);
    },
    onChange(option) {
      setPhoneCodeError(null);
      setSelectedPhoneCode(option);
    }
  };
  const emailProps = {
    type: "",
    label: emailLabel.value,
    value: enteredEmail,
    warningMessage: emailError,
    showError: !!emailError,
    onFocus() {
      setEmailError(null);
    },
    onBlur(e) {
      setEnteredEmail(e.target.value);
      const reg = /[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,4}$/;
      if(e.target.value){
        let value = e.target.value;
        let index = -1;
        let other = null;

        if (emailFormat && emailFormat.length > 0) {
          emailFormat.forEach((item) => {
            if (value.indexOf(item) > -1) {
              index = value.indexOf(item);
              other = value.replace(item, "")
            }
          });
        }
        let isValid = false;
        if (index && other) {
          isValid = reg.test(value) && index === other?.length;
        } else {
          isValid = reg.test(value);
        }
        setEmailIsValid(isValid);
        setEmailError(isValid ? null : emailWarningMessage.value);
      }
    }
  };
	const countryProps = {
    placeholder: countryLabel.value,
    options: countryOptions,
    selectedOption: selectedCountry,
    warningMessage: countryError,
    showError: !!countryError,
    onFocus() {
      setCountryError(null);
    },
    onChange(option) {
      setCountryError(null);
      setSelectedCountry(option);
      setSelectedCity(null);
      option && getArea(option)
    }
  };
	const topicProps = {
		placeholder: topicLabel?.value,
		options: topicList,
		selectedOption: selectedTopic,
		warningMessage: topicError,
		showError: !!topicError,
		onFocus() {
		  setTopicError(null);
		},
		onChange(option) {
		  setTopicError(null);
		  setSelectedTopic(option);
			if(option?.code === 'aftersales') {
				let item = indentifyList.find((x) => x.code == 'owner');
				setSelectedIdentity(item);
			}
		}
	}
	const identityProps = {
		placeholder: identityLabel?.value,
		options: indentifyList,
		selectedOption: selectedIdentity,
		warningMessage: identityError,
		showError: !!identityError,
		onFocus() {
		  setIdentityError(null);
		},
		onChange(option) {
		  setIdentityError(null);
		  setSelectedIdentity(option);
		}
	}
  const cityProps = {
    placeholder: cityLabel.value,
    options: cityOptions,
    selectedOption: selectedCity,
    warningMessage: cityError,
    showError: !!cityError,
    onFocus() {
      setCityError(null);
    },
    onChange(option) {
      setCityError(null);
      setSelectedCity(option);
    }
  };
  const commentsProps = {
    label: commentsLabel.value,
    value: enteredComments,
    showError: !!commentsError,
    warningMessage: commentsError,
    maxLength: 500,
    onFocus() {
      setCommentsError(null);
    },
    onChange(e) {
      setCommentsError(null);
      setEnteredComments(e.target.value);
    }
  };
  const policyProps = {
    label: policyError ?? policyLabel.value,
    checked: policyChecked,
    error: !!policyError,
    onChange(checked) {
      setPolicyError(null);
      setPolicyChecked(checked);
    }
  };
  const submitProps = {
    buttonText: submitBtnText.value,
    colorScheme: submitBtnColorScheme,
    iconName: submitBtnIcon,
    async callback(e) {
      await onSubmit();
    }
  };
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(function(position) {
      // console.log("Latitude is :", position.coords.latitude);
      // console.log("Longitude is :", position.coords.longitude);
    }, function(error) {
      console.error("Error Code = " + error.code + " - " + error.message);
    });
		 
    init().catch();
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);
  return (
    <div className="c-contact-us grid" ref={rootNode}>
      {!submitted && (
        <div className="c-contact-us__main">
          <div className="c-contact-us__header">
            <Heading html={title} type={titleType} />
          </div>
          <div className="c-contact-us__form">
            <Input className="c-contact-us__form-name" {...nameProps} />
            <Input className="c-contact-us__form-email" {...emailProps} />
            {/*<Dropdown className="c-contact-us__form-gender" {...genderProps} />*/}
            <div className="c-contact-us__form-phone" >
              <FilterDropdown cRef={phoneCodeNode} className="c-contact-us__form-country-number" {...phoneCodeProps} />
              <Input {...phoneProps} />
            </div>
            <FilterDropdown className="c-contact-us__form-country" {...countryProps} />
            {/*<Dropdown className="c-contact-us__form-city" {...cityProps} />*/}
						<FilterDropdown className="c-contact-us__form-topic" {...topicProps} />
						<FilterDropdown className="c-contact-us__form-identity" {...identityProps} />
            <Textarea className="c-contact-us__form-comments" {...commentsProps} />
          </div>
          <Checkbox className="c-contact-us__form-mandatory" {...policyProps} />
          <div className="c-contact-us__cta">
            <PrimaryButton className="c-contact-us__cta-submit" {...submitProps} />
          </div>
          {serverError && <div className="error-message">{serverError}</div>}
        </div>
      )}
      {submitted && (
        <div className="c-contact-us__main">
          <div className="c-contact-us__header">
            {selectedTopic.code !== 'aftersales' && <Heading html={successTitle} type={titleType} />}
						{selectedTopic.code === 'aftersales' && <Heading html={aftersalesSuccessTitle} type={titleType} />}
          </div>
          {selectedTopic.code !== 'aftersales' && <BodyText html={successBody} className="c-contact-us__success-body" />}
					{selectedTopic.code === 'aftersales' && <BodyText html={aftersalesSuccessBody} className="c-contact-us__success-body" />}
        </div>
      )}
    </div>
  );
};
export default ContactUs;
